import Vue, {onBeforeMount, onBeforeUnmount} from 'vue'
import App from './App.vue'
import vuetify from "@/base_lib/plugins/vuetify"
import vuesax from '@/base_lib/plugins/vuesax'
import baseStore from "@/base_lib/store"
import createAxios from "@/base_lib/network/api"
import router from "@/router"
import Application from "@/base_lib/helper/app"
import socket from "@/base_lib/plugins/socket"
import VueSocketIO from "vue-socket.io"
import teams from "@/store/teams"
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate"
import vuePersist from "@/base_lib/store/persist"
import app from "@/base_lib/store/module/app"
import auth from "@/base_lib/store/module/auth"
import { hasPermission, hasAnyPermission, hasAllPermissions } from "@/utils/permissionHelper"

Vue.config.productionTip = false

// Init vuesax
vuesax()

// Init store
const store = new Vuex.Store({
  modules: {
    teams,
    app,
    auth,
  },
  strict: process.env.NODE_ENV !== 'production',
  plugins: [createPersistedState(vuePersist)],
})
Vue.prototype.$stateManagement = store

// Init permission helper
Vue.prototype.$can = function(permission) {
  const permissions = this.$stateManagement.getters["auth/permissions"] || []
  return hasPermission(permissions, permission)
}

Vue.prototype.$canAny = function(permissionArray) {
  const permissions = this.$stateManagement.getters["auth/permissions"] || []
  return hasAnyPermission(permissions, permissionArray)
}

Vue.prototype.$canAll = function(permissionArray) {
  const permissions = this.$stateManagement.getters["auth/permissions"] || []
  return hasAllPermissions(permissions, permissionArray)
}

// Init axios
Vue.prototype.$http = createAxios()

// Vue Socket
if (socket.isEnabled()) {
  const mySocket = socket.setupSocketConnection()
  if (mySocket) {
    Vue.use(new VueSocketIO({
      debug: false,
      connection: mySocket,
      vuex: {
        store,
        actionPrefix: "SOCKET_",
      }
    }))
  }
}

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
  methods: {
    slugify: Application.helpers.slug,
    isDate: Application.helpers.isDate,
    formatDate: Application.helpers.formatDate,
    getBaseUrl: Application.helpers.getBaseUrl,
    can(permission) {
      return this.$can(permission)
    },
    canAny(permissionArray) {
      return this.$canAny(permissionArray)
    },
    canAll(permissionArray) {
      return this.$canAll(permissionArray)
    },
  },
  mounted() {
    Array.prototype.insert = function (index, item) {
      this.splice(index, 0, item);
    }
    Array.prototype.id = function () {
      if (this.length === 0) return this
      if (this[0]['id'] !== undefined) return this
      return this.map((item, index) => ({
        ...item,
        id: index,
      }))
    }
  },
  beforeDestroy() {
    this.$socket?.disconnect()
  },
  beforeCreate() {
  }
}).$mount('#app')

window.ATL_JQ_PAGE_PROPS = {
  "triggerFunction": function(showCollectorDialog) {
    Vue.prototype.$showCollectorDialog = showCollectorDialog
  },
  fieldValues: () => {
   let values = {
     summary: 'There is an issue on:',
     description: `... is not working correctly. \n\n\nURL: ${window.location.href}.\nUser Agent: ${navigator.userAgent}.\nScreen Resolution: ${screen.width}x${screen.height}`,
     priority: '3'
   }

   return values
  },
};
